<i2a-spinner *ngIf="!humanExpression"></i2a-spinner>
{{ humanExpression }}